import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6780c9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-4" }
const _hoisted_2 = {
  key: 0,
  class: "title mb-1"
}

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import { NotificationType } from '@/shared/models/AppNotification'

type Props = {
  type?: NotificationType
  title?: string
  hasIcon?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    type: { default: 'warning' },
    title: { default: undefined },
    hasIcon: { type: Boolean, default: true }
  },
  setup(__props: any) {

const icon = {
  warning: 'warning-round',
  error: 'warning-triangle',
  lukso: 'warning-round',
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notification", _ctx.type])
  }, [
    (_ctx.type && _ctx.hasIcon)
      ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          name: icon[_ctx.type],
          class: "icon"
        }, null, 8 /* PROPS */, ["name"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "action")
    ])
  ], 2 /* CLASS */))
}
}

})